import React from "react";
import TotalRecentHx from "./../TotalRecentHx";
import DashboardCalendar from "./../DashboardCalendar";

export default function HmLayout3({ className }) {
  return (
    <div>
        <TotalRecentHx className="mb-10"/>
        <DashboardCalendar className="mb-10"/>
    </div>
  );
}
